<template>
  <div
    ref="track"
    class="range track"
    :style="{height: '150px'}"
    :draggable="false"
    @mousedown.stop.prevent="onClickTrack"
  >
    <div
      class="bar"
      :style="{ height: `${currentPos * 100}%` }"
      :draggable="false"
    ></div>
    <div
      class="thumb"
      :class="{ active: isMoving }"
      :style="{ bottom: `${currentPos * 100}%` }"
      :draggable="false"
      @mousedown.stop.prevent="startMove"
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    step: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      trackStart: 0,
      trackSize: 0,
      isMoving: false
    };
  },
  computed: {
    currentPos() {
      let pos = ((this.value || 0) - this.min) / (this.max - this.min);
      return pos;
    }
  },
  watch: {},
  mounted() {
    this.initPos();
    window.addEventListener('resize', this.initPos);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.initPos);
  },
  methods: {
    initPos() {
      let rect = this.$refs.track.getBoundingClientRect();
      this.trackStart = rect.bottom;
      this.trackSize = rect.height;
    },
    startMove() {
      this.initPos();
      this.isMoving = true;
      this.$emit('startMove');
      window.addEventListener('mousemove', this.moving);
      window.addEventListener('mouseup', this.endMove);
    },
    moving(e) {
      this.updateValue(e.clientY);
    },
    endMove() {
      window.removeEventListener('mousemove', this.moving);
      window.removeEventListener('mouseup', this.endMove);
      this.isMoving = false;
      this.$emit('endMove');
    },
    updateValue(axis) {
      let progress = this.trackStart - axis;
      progress = progress / this.trackSize;
      progress = progress * (this.max - this.min);
      let value = progress;
      if (this.step) {
        value = Math.round(progress / this.step) * this.step;
        value = value.toFixed(0) - 0;
      }
      value = Math.max(Math.min(value, this.max), this.min);
      this.$emit('input', value);
    },
    onClickTrack(e) {
      this.startMove();
      this.updateValue(e.clientY);
    }
  }
};
</script>

<style lang="scss" scoped>
$track-width: 2px;
.track {
  position: relative;
  width: $track-width;
  background-color: rgba(#fff, 0.5);
  border-radius: 5px;
  margin-left: auto;
  margin-right: auto;
}
.bar {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 0;
  width: $track-width;
  background: #fff;
  border-radius: 5px;
}
.thumb {
  $thumb-width: 10px;
  $thumb-height: $thumb-width;

  position: absolute;
  bottom: 0;
  left: 0;
  margin-left: -($thumb-height - $track-width) / 2;
  margin-bottom: -$thumb-width / 2;
  width: $thumb-width;
  height: $thumb-height;
  background: #ffffff;
  box-shadow: 0px 5px 30px 0px rgba(22, 64, 234, 0.16);
  border-radius: 50%;
  user-select: none;
  // cursor: grab;
  transition-property: transform;
  transition-duration: 0.3s;
  &.active,
  &:hover {
    transform: scale(1.2);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/draftPreview/presentation/volumeRange.vue